import React from 'react';
import { HiX } from 'react-icons/hi';

const formatRegisteredAt = (value) => {
  if (!value) return '-';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '-';

  const months = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];
  const day = d.getDate();
  const month = months[d.getMonth()];
  const year = d.getFullYear();
  let hours = d.getHours();
  const minutes = String(d.getMinutes()).padStart(2, '0');
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12 || 12;

  return `${day} ${month}, ${year} ${hours}:${minutes} ${ampm}`;
};

const UserModelView = ({ user, isOpen, onClose }) => {
  if (!isOpen || !user) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-6 md:p-10 overflow-hidden">
      <div className="bg-white rounded-2xl shadow-xl max-w-xl md:ml-0 lg:ml-24 xl:ml-0 w-full max-h-[90vh] overflow-hidden flex flex-col no-scrollbar">
        <div className="bg-white border-b border-gray-200 px-6 py-4 flex items-center justify-between flex-shrink-0">
          <h2 className="text-xl font-bold text-gray-800">User Details</h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 transition-colors"
          >
            <HiX className="w-6 h-6" />
          </button>
        </div>
        <div className="p-6 overflow-y-auto flex-1 no-scrollbar">
          {/* Profile Section */}
          <div className="flex items-start gap-4 mb-6">
            {user.image ? (
              <img
                src={user.image}
                alt={user.name}
                className="w-20 h-20 rounded-full object-cover border-2 border-gray-300"
                onError={(e) => {
                  e.target.style.display = 'none';
                  if (e.target.nextElementSibling) {
                    e.target.nextElementSibling.style.display = 'flex';
                  }
                }}
              />
            ) : null}
            <div className={`w-20 h-20 rounded-full bg-gray-200 flex items-center justify-center border-2 border-gray-300 ${user.image ? 'hidden' : ''}`}>
              <span className="text-gray-600 text-2xl font-semibold">
                {user.name?.charAt(0)?.toUpperCase() || 'U'}
              </span>
            </div>
            <div className="flex-1 mt-4">
              <div className="flex items-center gap-2 -mb-1">
                <h3 className="text-xl font-semibold text-gray-800">{user.name || 'N/A'}</h3>
              </div>
              <p className="text-gray-600 text-sm">{user.email || 'N/A'}</p>
            </div>
          </div>

          {/* Two Column Grid for All Fields */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="flex items-center gap-2">
              <label className="text-xs font-medium text-[#7D7D7D] uppercase min-w-[140px]">Phone:</label>
              <p className="text-gray-800 text-sm">{user.phone || '--'}</p>
            </div>
            <div className="flex items-center gap-2">
              <label className="text-xs font-medium text-[#7D7D7D] uppercase min-w-[140px]">Registered At:</label>
              <p className="text-gray-800 text-sm">{formatRegisteredAt(user.createdAt || user.created_at)}</p>
            </div>
            <div className="flex items-center gap-2">
              <label className="text-xs font-medium text-[#7D7D7D] uppercase min-w-[140px]">Country:</label>
              <p className="text-gray-800 text-sm">{user.country || '--'}</p>
            </div>
            <div className="flex items-center gap-2">
              <label className="text-xs font-medium text-[#7D7D7D] uppercase min-w-[140px]">Social Login:</label>
              <p className="text-gray-800 text-sm">{user.is_social_login !== undefined ? (user.is_social_login   ? 'Yes' : 'No'): '--'}</p>
            </div>
            <div className="flex items-center gap-2">
              <label className="text-xs font-medium text-[#7D7D7D] uppercase min-w-[140px]">Lives:</label>
              <p className="text-gray-800 text-sm">{user.lives !== undefined ? user.lives : '--'}</p>
            </div>
            <div className="flex items-center gap-2">
              <label className="text-xs font-medium text-[#7D7D7D] uppercase min-w-[140px]">Points:</label>
              <p className="text-gray-800 text-sm">{user.points !== undefined ? user.points : '--'}</p>
            </div>
            <div className="flex items-center gap-2">
              <label className="text-xs font-medium text-[#7D7D7D] uppercase min-w-[140px]">Streak:</label>
              <p className="text-gray-800 text-sm">{user.streak !== undefined ? user.streak : '--'}</p>
            </div>
            {/* <div className="flex items-center gap-2">
              <label className="text-xs font-medium text-[#7D7D7D] uppercase min-w-[140px]">Last Life Reset Date:</label>
              <p className="text-gray-800 text-sm">{user.last_life_reset_date || user.lastLifeResetDate || '--'}</p>
            </div>
            <div className="flex items-center gap-2">
              <label className="text-xs font-medium text-[#7D7D7D] uppercase min-w-[140px]">Last Streak Date:</label>
              <p className="text-gray-800 text-sm">{user.last_streak_date || user.lastStreakDate || '--'}</p>
            </div>
            <div className="flex items-center gap-2">
              <label className="text-xs font-medium text-[#7D7D7D] uppercase min-w-[140px]">Streak Start Date:</label>
              <p className="text-gray-800 text-sm">{user.streak_start_date || user.streakStartDate || '--'}</p>
            </div>
            <div className="flex items-center gap-2">
              <label className="text-xs font-medium text-[#7D7D7D] uppercase min-w-[140px]">Streak End Date:</label>
              <p className="text-gray-800 text-sm">{user.streak_end_date || user.streakEndDate || '--'}</p>
            </div> */}
            {/* <div className="flex items-center gap-2">
              <label className="text-xs font-medium text-[#7D7D7D] uppercase min-w-[140px]">Last Completed Chapter Date:</label>
              <p className="text-gray-800 text-sm">{user.last_completed_chapter_date || user.lastCompletedChapterDate || '--'}</p>
            </div>
            <div className="flex items-center gap-2">
              <label className="text-xs font-medium text-[#7D7D7D] uppercase min-w-[140px]">Last Completed Quiz Date:</label>
              <p className="text-gray-800 text-sm">{user.last_completed_quiz_date || user.lastCompletedQuizDate || '--'}</p>
            </div> */}
            <div className="flex items-center gap-2">
              <label className="text-xs font-medium text-[#7D7D7D] uppercase min-w-[140px]">Referred By:</label>
              <p className="text-gray-800 text-sm">{user.referred_by || user.referredBy || '--'}</p>
            </div>
            <div className="flex items-center gap-2">
              <label className="text-xs font-medium text-[#7D7D7D] uppercase min-w-[140px]">Referral Count:</label>
              <p className="text-gray-800 text-sm">{user.referral_count !== undefined ? user.referral_count : (user.referralCount !== undefined ? user.referralCount : '--')}</p>
            </div>
            <div className="flex items-center gap-2">
              <label className="text-xs font-medium text-[#7D7D7D] uppercase min-w-[140px]"> Referral Karma Coins:</label>
              <p className="text-gray-800 text-sm">{user.total_referral_coins_earned !== undefined ? user.total_referral_coins_earned : (user.totalReferralCoinsEarned !== undefined ? user.totalReferralCoinsEarned : '--')}</p>
            </div>
            <div className="flex items-center gap-2">
              <label className="text-xs font-medium text-[#7D7D7D] uppercase min-w-[140px]">Is Premium:</label>
              <p className="text-gray-800 text-sm">{user.is_premium !== undefined ? (user.is_premium ? 'Yes' : 'No') : (user.isPremium !== undefined ? (user.isPremium ? 'Yes' : 'No') : '--')}</p>
            </div>
            {/* <div className="flex items-center gap-2">
              <label className="text-xs font-medium text-[#7D7D7D] uppercase min-w-[140px]">Pending Referral Code:</label>
              <p className="text-gray-800 text-sm">{user.pending_referral_code || user.pendingReferralCode || '--'}</p>
            </div>
            <div className="flex items-center gap-2">
              <label className="text-xs font-medium text-[#7D7D7D] uppercase min-w-[140px]">Referral Code:</label>
              <p className="text-gray-800 text-sm">{user.referral_code || user.referralCode || '--'}</p>
            </div>
            <div className="flex items-center gap-2">
              <label className="text-xs font-medium text-[#7D7D7D] uppercase min-w-[140px]">Version:</label>
              <p className="text-gray-800 text-sm">{user.__v !== undefined ? user.__v : '--'}</p>
            </div> */}
            <div className="flex items-center gap-2">
              <label className="text-xs font-medium text-[#7D7D7D] uppercase min-w-[140px]">Karma Coin:</label>
              <p className="text-gray-800 text-sm">{user.karma_coins !== undefined ? user.karma_coins : (user.karmaCoin !== undefined ? user.karmaCoin : '--')}</p>
            </div>
          </div>
        </div>
        <div className="bg-white border-t border-gray-200 px-6 py-4 flex justify-end gap-2 flex-shrink-0">
          <button
            onClick={onClose}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default UserModelView;

